// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1xi28err{right:var(--_1hx5ohh)}\n._94n58err{bottom:var(--_1hx5ohh)}\n._k8m01rjc{transition-property:transform,opacity}\n._kqsw1n9t{position:fixed}", ""]);
// Exports
module.exports = exports;
